<template>
  <div>
    <div class="user_content">
      <img src="../../assets/img/trustlook-logo.png" alt="" class="logo" />
      <div class="sign">
        <span @click="jump('/register')">{{ $t('user.SignUp') }}</span>
        <span ref="lang">
          <span @click="languageStatus = !languageStatus" class="choose icon-lang"></span>
          <el-collapse-transition>
            <ul class="language_selection" v-show="languageStatus">
              <li @click="switchLang('zh')" :class="{ active: lang === 'zh' }">中文</li>
              <li @click="switchLang('en')" :class="{ active: lang === 'en' }">English</li>
            </ul>
          </el-collapse-transition>
        </span>
      </div>
      <div class="login_container">
        <h2 class="title">{{ $t('user.SignIn') }}</h2>
        <form class="form">
          <div class="form-items">
            <input type="text" v-model="email" id="email" :placeholder="$t('user.Email')" />
          </div>
          <div class="form-items">
            <input
              type="password"
              v-model="password"
              id="password"
              :placeholder="$t('user.Password')"
              @keyup.enter="getEnterCode"
            />
          </div>
          <div class="forgotPass">
            <span @click="jump('/forgotPass')">{{ $t('user.forgotPassword') }}</span>
          </div>
          <div class="btn_sign" @click="login">
            <i class="el-icon-loading" v-if="loading"></i>{{ $t('user.SignIn') }}
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import router from '../../router'
  import axios from 'axios'
  import { Message } from 'element-ui'
  import VueRouter from 'vue-router'

  const { isNavigationFailure, NavigationFailureType } = VueRouter

  export default {
    name: 'SignIn',
    data() {
      return {
        email: '',
        password: '',
        loading: false,
        languageStatus: false
      }
    },
    methods: {
      getEnterCode: function(e) {
        var keyCode = window.event ? e.keyCode : e.which
        if (keyCode == 13) {
          this.login()
        }
      },
      login() {
        this.loading = true
        let data = {
          email: this.email,
          password: this.password
        }
        axios
          .post('/api/login', data)
          .then(res => {
            this.loading = false
            localStorage.setItem('email', this.email)
            localStorage.setItem('password', this.password)
            router.push('/dashboard').catch(err => {
              if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
                throw Error(err)
              }
            })
          })
          .catch(err => {
            this.loading = false
            Message({ type: 'error', message: this.$t('errMsg.err2'), showClose: true })
          })
      },
      jump(url) {
        this.$router.push(url).catch(err => {
          // to hide the below error message
          if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
            throw Error(err)
          }
        })
      },
      switchLang(lang) {
        if (lang === this.$store.state.lang) return
        this.$store.commit('switchLang', lang)
        this.languageStatus = false
        Message({
          type: 'success',
          message: this.$t('message.switchSuccessfully'),
          showClose: true
        })
        location.reload()
      }
    },
    computed: {
      lang() {
        return this.$store.state.lang
      }
    },
    mounted() {
      let _this = this
      document.addEventListener('click', e => {
        if (!!_this.$refs.lang && !!_this.$refs.lang.contains(e.target)) return
        _this.languageStatus = false
      })
    }
  }
</script>
<style lang="scss" src="./user.scss" scoped></style>
<style lang="scss" scoped>
  .login_container {
    width: 520px;
    height: 463px;
    background: $bg-user-color;
    @include box-shadow2;
    @include border-radius(10px);
    box-sizing: border-box;
    padding: 60px 60px 0;
    color: #f3f6fe;
    .title {
      height: 29px;
      text-align: center;
      font-size: 24px;
      color: $white;
      margin-bottom: 8px;
      font-weight: bold;
      font-family: NexaBold;
    }
    .form {
      .form-items {
        width: 400px;
        margin-top: 40px;
        & > input {
          width: 400px;
          height: 48px;
          background: rgba(42, 48, 74, 0.5);
          box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2);
          @include border-radius(24px);
          border: 0;
          color: rgba(255, 255, 255, 0.8);
          text-indent: 20px;
          font-size: 16px;
          font-family: Lato-Regular;
        }
      }
      .forgotPass {
        font-family: Lato-Regular;
        color: $primary-color;
        text-align: right;
        font-size: 14px;
        margin: 16px 14px 30px 0;
        cursor: pointer;
      }
    }
  }
  @media screen and (max-width: 450px) {
    .login_container {
      width: 100%;
      padding: 60px 40px 0;
      background: none;
      box-shadow: none;
      .form {
        .form-items {
          width: 100%;
          & > input {
            width: 100%;
            height: 40px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/user/login.vue